<template>
  <div class="modal_backdrop" v-if="visible">
    <div class="modal_card">
      <!-- Icon Badge -->
      <div class="icon_badge">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"></polyline>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          <line x1="10" y1="11" x2="10" y2="17"></line>
          <line x1="14" y1="11" x2="14" y2="17"></line>
        </svg>
      </div>

      <!-- Title & Subtitle -->
      <h3 class="modal_title">
        Delete this {{ targetItem && targetItem.is_folder ? 'folder' : 'file' }}?
      </h3>
      <p class="modal_subtitle">This action cannot be undone.</p>

      <!-- Action Buttons -->
      <div class="btn_group">
        <button type="button" class="btn_cancel" @click="onCancel" :disabled="loading">
          Cancel
        </button>
        <button type="button" class="btn_confirm" @click="onConfirm" :disabled="loading">
          <i class="fa fa-spinner fa-spin mr-1" v-if="loading"></i>
          {{ loading ? 'Deleting...' : 'Yes, Delete' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BriefcaseDeleteModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    targetItem: {
      type: Object,
      default: () => ({})
    },
    isShared: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onCancel() {
      this.$emit('close');
    },
    onConfirm() {
      this.$emit('confirm', {
        item: this.targetItem,
        isShared: this.isShared
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal_backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.78);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;

  .modal_card {
    background: #000000;
    width: 90%;
    max-width: 440px;
    border-radius: 14px;
    padding: 32px 28px 28px;
    text-align: center;
    box-shadow: 0 0 18px 2px rgba(220, 160, 20, 0.55);
    border: 1px solid rgba(220, 160, 20, 0.3);

    .icon_badge {
      width: 56px;
      height: 56px;
      margin: 0 auto 18px;
      border-radius: 50%;
      background: rgba(240, 68, 68, 0.12);
      border: 1px solid rgba(240, 68, 68, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        stroke: #ef4444;
      }
    }

    .modal_title {
      color: #ffffff;
      font-size: 19px;
      font-weight: 600;
      margin-bottom: 8px;
      letter-spacing: -0.2px;
    }

    .modal_subtitle {
      color: #94a3b8;
      font-size: 13px;
      margin-bottom: 26px;
    }

    .btn_group {
      display: flex;
      gap: 14px;
      justify-content: center;

      button {
        flex: 1;
        padding: 10px 18px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        border: none;
        transition: all 0.2s ease;
        outline: none;

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }

      .btn_cancel {
        background: #501b1f;
        color: #ffffff;

        &:hover:not(:disabled) {
          background: #6a242a;
        }
      }

      .btn_confirm {
        background: #004d5a;
        color: #ffffff;

        &:hover:not(:disabled) {
          background: #006374;
        }
      }
    }
  }
}
</style>